import React, { Component } from 'react';
import date from 'date-and-time';
import Moment from 'react-moment'
import  Image  from "./image.js"
// import "./home.css"
import {
  Redirect , Link 
} from 'react-router-dom'
class Ticket extends Component {

  constructor(props){
    super(props)
    this.state={
        isEdit: false,
        message:"",
        alertDelete:false,
        imageshow:false,
        uploading:false,
        body:"",
        dateDate : false
        

    }
 }

 upDatenote =(event)=>{
  event.preventDefault();
  this.setState({ body: event.target.value }); 
  // console.log("data ------>element", this.state.body) 
}


componentDidMount(){
  this.setState((state, props) => ({
     body : props.payment.description
  }));
  
}


imageE= (data)=>{
//  console.log("data ------>element", data.imageerror)
 if(data){
  if(data.imageerror === "true") {
    // console.log("data ------>element true", data)
       this.timeout()
      }else{
        // console.log("data ------>element false 2", data)
     }
          
 }else{
  // console.log("data ------>element false 1", data)
 }
   


}

updateTicket=(e)=>{
  e.preventDefault();
  this.setState({
    dateDate : true
  })
  // console.log("new update====>",  this.amount.value, this.name.value, this.venue.value, this.state.body)
  const data = {
    amount:  this.amount.value,
    name :this.name.value,
    venue : this.venue.value,
    description :this.state.body
  }
  this.props.TicketUpdate(data)
  this.setState({
    dateDate : false
  })
}
 
timeout() {
  setTimeout(function() {
    this.setState({ imageshow:false})
    console.log(this.state.noticeshow);
  }.bind(this), 4000);
}

closeImage=(event)=>{
  event.preventDefault();
   this.setState({ imageshow:false})
}

imageShow = (event)=>{
  event.preventDefault();
   this.setState({ imageshow:true})
}
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
 console.log("props data---=====>", this.props.payment)

  
    return (
            <div className="Home"> 
           
              <div className="build-ticket-form-body">
                <div className="build-ticket-body-card">
                  <div className="build-ticket-form-title">
                       <p className="build-ticket-form-date">
                          { this.props.payment ?
                           <small>
                              { this.props.payment.createdAt?
                                   <Moment  format="DD/MM/YYYY" date={this.props.payment.createdAt} /> 
                                  :
                                  <small> no data yet</small>
                              }
                            </small>
                            :
                            <small></small>
                          }
                       
                       </p>
                      <p className="build-ticket-form-p">
                      
                      { this.props.payment ?
                        <small>
                          { this.props.payment.name ?
                              <small>{this.props.payment.name} </small>
                              :
                              <small>no data yet</small>
                          }
                        </small>
                        :
                        <small></small>
                      }
                     </p>
                      
                      <p className="build-ticket-form-value">
                          { this.props.payment ?
                            <small>
                              { this.props.payment.venue ?
                                  <small><b>Total ticket :</b> {this.props.payment.venue} </small>
                                  :
                                  <small> no data yet </small>
                              }
                            </small>
                            :
                            <small>  </small>
                          }
                      </p>
                  </div>
                </div>
                <br/>
                {
                  this.state.imageshow?
                    <div className="build-ticket-body-from-sub">
 {
                         this.props.payment ?
                          <div> 
                            {
                              this.props.payment._id ?

                                // < Image  payment_id={this.state.payment_id}  imageE={this.imageE}  payment={this.state.datapayment} />
                                 < Image payment={this.props.payment} payment_id={this.props.payment._id}   imageE={this.imageE} /> 
                              //  <div></div>
                                :
                               <p></p>   
                            }
                          </div>
                          :
                          <p></p>
                        }
                        <div>
                        <button className="button is-success is-outlined" onClick={this.closeImage}>
                              
                              <i className="fas fa-long-arrow-alt-left">  </i>  Back
                        </button>
                        </div>

                    </div>
                    :
                    <div>
                      <div className="build-ticket-button-image">
                    <button className="button is-success is-outlined" onClick={this.imageShow}>
                          <i className="fas fa-images icon-link"></i>
                        View logo
                    </button>
                </div>
                <div className="build-ticket-body-from">
                  <form onSubmit={this.updateTicket}>
                    <div className="build-ticket-body-from-sub">
                    <div className="field">
                        <label className="label">Name</label>
                        <div className="control">
                          {
                            this.props.payment ? 
                            <p>
                                {
                                  this.props.payment.name? 
                                  <input className="input" type="text"   
                                  ref={ input => this.name = input} 
                                  defaultValue={this.props.payment.name}
                                    placeholder="Enter name"/>
                                  :
                                   <p>
                                     <input className="input" type="text"   
                                       ref={ input => this.name = input} 
                                 
                                    placeholder="Enter name"/>
                                   </p>
                                }
                            </p>
                            :
                            <p>
                              
                                     <input className="input" type="text"   
                                       ref={ input => this.name = input} 
                                 
                                    placeholder="Enter name"/>
                                   
                            </p>
                          }
                       
                          {/* <input className="input" type="text"   
                           ref={ input => this.name = input} 
                           defaultValue={this.props.payment.name}
                            placeholder="Text input"/> */}
                        </div>
                      </div>

                      <div className="field">
                        <label className="label">Amount</label>
                        <div className="control">
                        {
                            this.props.payment ? 
                              <p>
                                 {
                                    this.props.payment.amount? 
                                    <input className="input" type="text"   
                                    ref={ input => this.amount = input} 
                                    defaultValue={this.props.payment.amount}
                                      placeholder="Enter amount"/>
                                  :
                                   <p>
                                     <input className="input" type="text"   
                                       ref={ input => this.amount = input} 
                                 
                                    placeholder="Enter amount"/>
                                   </p>
                                }
                            </p>
                            :
                            <p>
                                <input className="input" type="text"   
                                   ref={ input => this.amount = input} 
                                placeholder="Enter amount"/>
            
                            </p>
                          }
                         
                        </div>
                      </div>

                      <div className="field">
                        <label className="label">Venue</label>
                        <div className="control">
                            {
                                this.props.payment ? 
                                  <p>
                                    {
                                        this.props.payment.venue? 
                                        <input className="input" type="text"   
                                        ref={ input => this.venue = input} 
                                        defaultValue={this.props.payment.venue}
                                          placeholder="Enter venue"/>
                                      :
                                      <p>
                                        <input className="input" type="text"   
                                          ref={ input => this.venue = input} 
                                    
                                        placeholder="Enter venue"/>
                                      </p>
                                    }
                                </p>
                                :
                                <p>
                                    <input className="input" type="text"   
                                      ref={ input => this.venue = input} 
                                    placeholder="Enter venue"/>
                
                                </p>
                              }
                        </div>
                      </div>

                      <div className="field">
                        <label className="label">Description</label>
                        <div className="control">
                            {

                                    this.props.payment ? 
                                      <p>
                                 
                                        {
                                           this.props.payment.description? 
                                        
                                              <textarea className="textarea "  rows="4" cols="90" 
                                              value={this.state.body} onChange={this.upDatenote} 
                                              // defaultValue={this.props.payment.description}  
                                              ref={ input => this.body = input}    placeholder="Description" required>
                                            </textarea> 
                                          :
                                          <p>
                                            { this.props.payment.description}
                                         <textarea className="textarea "  rows="4" cols="90" 
                                              value={this.state.body} onChange={this.upDatenote} 
                                              // defaultValue={this.props.payment.description}  
                                              ref={ input => this.body = input}    placeholder="Description" required>
                                            </textarea> 
                                          </p>
                                        }
                                    </p>
                                    :
                                    <p>
                                       
                    
                                    </p>
                                  }
                         
                        </div>
                      </div>

                      

                      <div className="field is-grouped">
                      <div className="control">
                           <Link to={`/form`}  className="button is-link is-small">
                                  <span className="icon is-small">
                                  <i className="fas fa-long-arrow-alt-left"></i>
                                  </span>
                                  <span> Back</span>
                             </Link>
                        </div>
                          {
                            this.state.dateDate ? 
                              <a className="button is-loading">Loading</a>
                              :
                            <div className="control">
                                <button className="button is-success">Save</button>
                            </div>
                          }
                        
                        
                      </div>
                    </div>
                   </form>
                 </div>
               </div>
               
                   
                }
                
              </div>
              
              
    
       
           </div>     

    )

}





}

export default Ticket;


// WEBPACK FOOTER //
// ./src/component/build/ticket.js